module.exports = __webpack_public_path__ + "static/media/gluten-free.8e74051f.svg";